import React from 'react'

function DetailProduct() {
    return (
        <div className='w-full'>
            <div className='w-full container mx-auto py-10 p-5 md:px-0'>
                <h2 className='text-2xl font-bold uppercase'>
                    Detalle de Productos
                </h2>

                <div className='w-full grid grid-cols-1 md:grid-cols-2 gap-20 justify-between mt-10'>
                    <div className='flex flex-col gap-3'>
                        <div>
                            <h3 className='text-base font-bold'>
                                Mora Control
                            </h3>
                            <p className='text-base  italic'>
                                "Recupera tu dinero de manera rápida, efectiva y automatizada."
                            </p>
                        </div>
                        <div>
                            <h3 className='text-base font-bold'>
                                Optimiza tu gestión de cobranza y recupera lo que te pertenece
                            </h3>
                            <p className='text-base  italic'>
                                Mora Control es una plataforma avanzada de gestión financiera que te permite
                                centralizar y automatizar el proceso de cobranza de manera eficiente. Con esta
                                herramienta, puedes subir tus facturas, gestionar avisos de pago y activar
                                recordatorios estratégicos a través de múltiples canales, incluyendo SMS, correos
                                electrónicos y cartas certificadas enviadas por Dicom. Además, te ofrece la posibilidad
                                de generar avisadores persuasivos para incentivar el pago oportuno, reduciendo la
                                morosidad y optimizando el flujo de caja de tu empresa.
                            </p>
                        </div>
                        <ul className='font-bold'>
                            <li>
                                ✅Carga y gestión de facturas en un solo lugar
                            </li>
                            <li>
                                ✅Automatización del proceso de cobranza con avisos programados
                            </li>
                            <li>
                                ✅Uso de múltiples canales de comunicación (SMS, email, carta certificada)
                            </li>
                            <li>
                                ✅Mejor control y seguimiento de pagos pendientes
                            </li>
                        </ul>
                    </div>
                    <div className='flex flex-col gap-3'>
                        <div>
                            <h3 className='text-base font-bold'>
                                Reportes Interactivos
                            </h3>
                            <p className='text-base  italic'>
                                "Evalúa bien a tus clientes y minimiza los riesgo"
                            </p>
                        </div>
                        <div>
                            <h3 className='text-base font-bold'>
                                Información financiera confiable para decisiones estratégicas
                            </h3>
                            <p className='text-base  italic'>
                                Los Reportes Interactivos de Equifax te brindan una visión completa y actualizada de la
                                condición financiera de tus clientes y proveedores. Con acceso a datos patrimoniales,
                                historial crediticio y análisis de riesgo de empresas y sus socios, esta herramienta es
                                clave para evaluar la solidez financiera de cualquier entidad antes de concretar una
                                relación comercial. Obtén informes detallados con información en tiempo real para
                                minimizar riesgos y tomar decisiones informadas con total confianza
                            </p>
                        </div>
                        <ul className='font-bold'>
                            <li>
                                ✅Evaluación financiera de clientes y proveedores en un solo informe
                            </li>
                            <li>
                                ✅Datos patrimoniales y antecedentes crediticios de empresas y socios
                            </li>
                            <li>
                                ✅Información clara y actualizada para mitigar riesgos comerciales
                            </li>
                            <li>
                                ✅Soporte estratégico para decisiones de negocio seguras
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default DetailProduct